export enum Routes {
  Applications = 'applications',
  Users = 'users',
  Profile = 'profile',
}
